export const MODAL = {
  MODAL_SEARCH: 'friend_search'
} as const;

export type ModalType = typeof MODAL[keyof typeof MODAL];
